import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SingleSelect } from 'src/web/components/Input/Dropdowns/SingleSelect';
import {
  OL_COLOUR_BLACK_10,
  OL_COLOUR_BLACK_55_HEX,
  OL_COLOUR_BLACK_90_HEX,
  OL_COLOUR_NAVY_BABY,
} from '../../../../../components/Style/colours';
import { MIXIN_ANCHOR_BUTTON } from '../../../../../components/Style/mixins';

export const StyledSingleSelect = styled(SingleSelect)({
  flexGrow: 1,
  '> .react-selectize.root-node': {
    width: '100%',
  },
});

export const FilterByUserSelect = styled(StyledSingleSelect)({
  flexBasis: 300,
});

export const InstitutionRoleSelect = styled(StyledSingleSelect)({
  flexBasis: 200,
});

export const CourseAssignedSelect = styled(StyledSingleSelect)({
  flexBasis: 300,
});

export const QuestionCircleIcon = styled(FontAwesomeIcon)({
  color: OL_COLOUR_NAVY_BABY,
  marginLeft: 8,
  fontSize: 14,
});

export const PopoverContentHeader = styled('div')({
  padding: 20,
  borderBottom: `1px solid ${OL_COLOUR_BLACK_10}`,
  fontSize: 14,
  fontWeight: 600,
});

export const PopoverContentBody = styled('div')({
  padding: 20,
  fontSize: 14,
  maxHeight: 300,
  overflowY: 'auto',
});

export const CoursesAssignedWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const CourseAssignedItem = styled('div')({
  display: 'flex',
  ':not(:last-child)': {
    marginBottom: 20,
  },
});

export const CourseAssignedItemBody = styled('div')({
  marginLeft: 10,
});

export const CourseImage = styled('img')({
  width: 46,
  height: 40,
});

export const CourseName = styled('div')({
  fontWeight: 600,
  maxWidth: 300,
});

export const CoursePath = styled('div')({
  color: OL_COLOUR_BLACK_55_HEX,
});

export const LoadMoreButton = styled('button')({
  ...MIXIN_ANCHOR_BUTTON,
  margin: '20px auto 0',
  display: 'block',
});

export const GroupName = styled('div')({
  ':not(:last-child)': {
    marginBottom: 20,
  },
});

export const TableHeading = styled('div')(
  ({ minWidth }: { minWidth?: number }) => ({
    whiteSpace: 'nowrap',
    minWidth: minWidth ?? 'auto',
  })
);

export const BulkActionButton = styled('button')({
  color: OL_COLOUR_BLACK_90_HEX,
  border: `1px solid ${OL_COLOUR_BLACK_55_HEX}`,
  borderRadius: '4px',
  fontFamily: 'inherit',
  fontWeight: 600,
  padding: '8px 10px',
});

export const BulkActionSortDownIcon = styled(FontAwesomeIcon)({
  marginLeft: 4,
  marginBottom: 2,
  color: OL_COLOUR_BLACK_55_HEX,
});

export const BulkActionContentWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  margin: '8px 0',
  hr: {
    margin: 0,
  },
});

export const BulkActionContentButton = styled('button')({
  ...MIXIN_ANCHOR_BUTTON,
  textAlign: 'left',
  padding: '8px 11px',
  color: OL_COLOUR_BLACK_90_HEX,
  fontWeight: 600,
  textDecoration: 'none',
  svg: {
    marginRight: 11,
  },
});

export const CoursesSpinnerWrapper = styled('div')({
  textAlign: 'center',
});
